import {isStaff, staffCan, StaffSessionModel} from '../../../../auth/core/staffAccess'
type CompanyScopedUser = {
  rl?: number
  cpi?: number
  staff?: StaffSessionModel | null
}

// The list request flag that asks the server for the newest registered invoices.
export const LATEST_INVOICE_LIST_QUERY = 'latest=true'

// Staff granted «صورتحساب‌ها» with no business selected list every business's sales. That list is the
// newest registered invoices only: a season, totals and charts over every business are a read of
// the whole invoice table, and they pick a business before working with any of them.
export const isAllBusinessSalesList = (user?: CompanyScopedUser | null, baseMode?: number) =>
  staffCan(user, 'invoices') && Number(user?.cpi || 0) <= 0 && (baseMode || 1) === 1

// Purchases are resolved from the selected business, and an archive over every business is a read
// of the whole invoice table: on both lists staff without a business pick one first and no list,
// summary or chart is requested until then. So do sales for staff not granted «صورتحساب‌ها».
export const waitsForSelectedBusiness = (user?: CompanyScopedUser | null, baseMode?: number) =>
  isStaff(user) &&
  Number(user?.cpi || 0) <= 0 &&
  (baseMode === 2 || baseMode === 3 || !isAllBusinessSalesList(user, baseMode))
